<template>
  <BaseBeatLoader
    v-if="showAppLoader"
    class="h-100 w-100 pos-absolute global-loader"
  />
  <div
    v-else
    class="d-flex-col h-100 w-100 pos-relative min-h-600-px"
  >
    <Toast class="z-index-7" />
    <BaseBeatLoader
      :loading="showGlobalLoader"
      v-if="showGlobalLoader"
      class="h-100 w-100 pos-absolute global-loader"
    />
    <router-view v-if="!isLoading" />
  </div>
</template>

<script setup lang="ts">
  import BaseBeatLoader from "@/components/base-beat-loader.vue";
  import Toast from "@/components/base-toast.vue";

  import { computed, inject, ref, toRaw, unref, watch, onMounted } from "vue";

  import { GLOBAL_STORE_INJECTION_KEY, ONBOARDING_STATUS_STORE_INJECTION_KEY } from "@/store/keys";
  import { useAuth0 } from "@auth0/auth0-vue";
  import analyticsService from "@/services/analytics.service";
  import Cookies from "js-cookie";
  import { CUSTOM_AUTH_NAME } from "./lib/constants";
  import { useRouter } from "vue-router";
  
  const { isLoading: isAuthLoading, user } = useAuth0();
  const showAppLoader = ref(true);
  const onboardingStore = inject(ONBOARDING_STATUS_STORE_INJECTION_KEY)!;
  const globalStore = inject(GLOBAL_STORE_INJECTION_KEY)!;
  const router = useRouter();

  onMounted(() => {
    initializeApp();
  });

  const initializeApp = async () => {
    const auth = Cookies.get(CUSTOM_AUTH_NAME);
    if (!auth) {
      onAuthNotFound();
    } else {
      showAppLoader.value = false;
    }
    globalStore.initOnResize();
  };

  const onAuthNotFound = () => {
    if (!window.location.pathname.includes("owner-verification")) {
      router.replace("signup");
    }
    showAppLoader.value = false;
  };

  watch(isAuthLoading, async (isAuthLoadingCurrentValue) => {
    if (isAuthLoadingCurrentValue === true) {
      return;
    }
    await analyticsService.identifyFromAuth0User(unref(user));
  });

  watch(() => onboardingStore.state.isInitialized, async (isOnboardingStatusInitializedCurrentValue) => {
    if (isOnboardingStatusInitializedCurrentValue) {
      await analyticsService.updateIdentityFromOnboardingStatus(toRaw(onboardingStore.state.onboardingStatus));
    }
  }, { immediate: true });

  const showGlobalLoader = computed(() => globalStore.state.isRouteLoading || globalStore.state.showGlobalLoader);
  const isLoading = computed(() => globalStore.state.isRouteLoading);
</script>

<style lang="scss">
@import "@/assets/base.css";

#app {
  background-color: $system-disabled-normal;
}

.global-loader {
  background-color: #EDEEF1;
  z-index: 10000;
}
</style>
